<button (click)="play()">Play</button>
<button (click)="pause()">Pause</button>
<button (click)="stop()">Stop</button>
